// Keeps the comparison table in step with the collection's filters and sort. Horizon re-renders
// only the product grid when a filter changes, so this re-fetches the comparison section for the
// new URL. Without JavaScript, a filter change reloads the page and the table is already correct.
(() => {
  if (window.marixiaCompare) return;
  window.marixiaCompare = true;

  let controller = null;

  const refresh = async () => {
    const marker = document.querySelector('[data-mx-compare]');
    if (!marker) return;
    const sectionId = marker.dataset.mxCompare;
    const wrapper = document.getElementById(`shopify-section-${sectionId}`);
    if (!wrapper) return;

    controller?.abort();
    controller = new AbortController();
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.getElementById(`shopify-section-${sectionId}`);
      if (!fresh) throw new Error('Section missing from response');
      wrapper.innerHTML = fresh.innerHTML;
    } catch (error) {
      if (error.name === 'AbortError') return;
      // Don't leave a table that no longer matches the products shown: replace it with a notice.
      const notice = document.createElement('p');
      notice.className = 'mx-callout';
      notice.setAttribute('role', 'status');
      const link = document.createElement('a');
      link.href = window.location.href;
      link.textContent = 'Reload the page';
      notice.append("The comparison couldn't be updated for this selection. ", link, ' to see it.');
      const table = wrapper.querySelector('.mx-compare-wrap');
      if (table) table.replaceWith(notice);
    }
  };

  document.addEventListener('shopify:collection:update', refresh);
  window.addEventListener('popstate', refresh);
})();
